/**
 * Redux actions for lists of assets.
 * @module redux/actions/runningOrder
 */

import { createAction } from 'redux-actions';

export const SHOW_SNACK = 'SNACKBAR/SHOW_SNACK';
export const DISMISS_SNACK = 'SNACKBAR/DISMISS_SNACK';

const showSnack = (
  id,
  data = {
    content: '',
    timeout: 7000,
    button: {}
  }
) => dispatch => dispatch(createAction(SHOW_SNACK)({ id, data }));

const dismissSnack = id => dispatch => dispatch(createAction(DISMISS_SNACK)({ id }));

export const actions = {
  showSnack,
  dismissSnack
};



// WEBPACK FOOTER //
// ./app/actions/snackbar.js